export const getSubCategoryKey = (subCategoryId: number) => {
    return `sub_categories.sub_category_${subCategoryId}`;
};
